<ambita-cadastre-report-buildings-wrapper class="ambita-cadastre-report-buildings-wrapper">
  <ambita-report-print-toolbar if="{ !opts.multipleReport }"/>
  <report-header date="{ opts.date }" if="{ !opts.multipleReport }"/>
  <ambita-loading-indicator show="{ loading }" loading-text="{ i18n.propertyLookup.loading }"/>
  <ambita-cadastre-report-error/>
  <ambita-cadastre-report-summary show="{ !loading }"/>
  <ambita-cadastre-report-buildings show="{ !loading }"/>
  <ambita-cadastre-report-disclaimer/>

  <script>
    import '../reportPrintToolbar/reportPrintToolbar.tag';
    import '../common/reportHeader.tag';
    import '../common/loadingIndicator.tag';
    import './cadastreReportError.tag';
    import './cadastreReportSummary.tag';
    import './sections/buildings.tag';
    import './cadastreReportDisclaimer.tag';
    import './cadastreReport.scss';
    import './cadastreReportPrint.scss';
    import '../../i18n/propertyLookupTranslations';
    import { init } from './cadastreReportWrapperController';

    init(this);
  </script>
</ambita-cadastre-report-buildings-wrapper>
